export default __webpack_public_path__ + "static/media/information--trucks-both-ways--g1.e3ecbd84.png";